import { Editor } from "grapesjs";

const customLandingSliderConfig = ({ editor }: { editor: Editor }) => {
	editor.BlockManager.add("custom-slider", {
		label: "Slider",
		category: "Media Slider",
		content: `
            <div class="swiper-container">
                <div class="py-4 relative group">
                    <div class="opacity-0 group-hover:opacity-100 transition-opacity absolute left-3 top-8 p-2 py-1 w-auto h-auto bg-gradient-to-r from-slate-900 to-slate-600 text-white text-xs rounded-md flex flex-col">
                        <span>* Swipe or scroll horizontally *</span>
                        <span>* Double tap to change slides</span>
                        <span>* Duplicate or delete slides</span>
                    </div>

                    <div class="overflow-x-auto snap-x snap-mandatory flex space-x-3 pb-2">
                    <img src="https://placehold.co/1920x600?text=Slide+2" alt="Slide 2" class="snap-start flex-shrink-0 w-full min-h-48">
                    <img src="https://placehold.co/1920x600?text=Slide+2" alt="Slide 2" class="snap-start flex-shrink-0 w-full min-h-48">
                    <img src="https://placehold.co/1920x600?text=Slide+2" alt="Slide 2" class="snap-start flex-shrink-0 w-full min-h-48">
                    </div>
                </div>
            </div>
        `,
	});

	editor.DomComponents.addType("slider", {
		model: {
			defaults: {
				tagName: "div",
				draggable: true,
				components: `
                <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide"><img src="https://via.placeholder.com/600x300" alt="Slide 1"></div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-pagination"></div>
                </div>
            `,
			},
		},
	});

	editor.TraitManager.addType("slides", {
		createInput({ trait }) {
			const el = document.createElement("button");
			el.innerText = "Add Slide";
			el.onclick = () => {
				const wrapper = this.target.find(".swiper-wrapper")[0];
				wrapper.append(
					'<div class="swiper-slide"><img src="https://via.placeholder.com/600x300" alt="New Slide"></div>'
				);
			};
			return el;
		},
	});

	editor.DomComponents.addType("slider", {
		model: {
			defaults: {
				traits: [{ type: "slides", label: "Slides" }],
			},
		},
	});
};

export default customLandingSliderConfig;
